import React from "react";
import Men from "../components/Men";

const MenPage = () => {
  return (
    <>
      <Men />
    </>
  );
};

export default MenPage;
